// extracted by mini-css-extract-plugin
module.exports = {"Tooltip__tooltip-wrap__h_QN5":"Tooltip__tooltip-wrap__h_QN5","Tooltip__tooltip-text__2Idfx":"Tooltip__tooltip-text__2Idfx"};